module.exports = __webpack_public_path__ + "static/media/IMG_2723.51c9513c.JPG";